import {fetchListings} from '../../actions/listings';
import {
    HIGHLIGHT_IN_MAP,
    CLEAR_MAP_HIGHLIGHT,
    NAVIGATE_CAROUSEL,
    CLEAR_CAROUSEL_FOCUS,
    HIDE_GOOGLE_MAP,
} from '../../actions/action-types';

export function onFetchListingsRetry(dispatch, segmentKey) {
    return () => {
        dispatch(fetchListings({segmentKey}));
    };
}

// Actions
export function highlightInMap(listingId) {
    return {
        type: HIGHLIGHT_IN_MAP,
        listingId,
    };
}

export function clearMapHighlight() {
    return {
        type: CLEAR_MAP_HIGHLIGHT,
    };
}

export function navigateCarousel(listingId) {
    return {
        type: NAVIGATE_CAROUSEL,
        listingId,
    };
}

export function clearCarouselFocus() {
    return {
        type: CLEAR_CAROUSEL_FOCUS,
    };
}

export function hideGoogleMap() {
    return {
        type: HIDE_GOOGLE_MAP,
    };
}

// Reducer
export default function reduceGreatPlaces(state = {}, action) {
    switch (action.type) {
        case HIGHLIGHT_IN_MAP:
            return {
                ...state,
                highlightedId: action.listingId,
            };

        case CLEAR_MAP_HIGHLIGHT:
            return {
                ...state,
                highlightedId: null,
            };

        case NAVIGATE_CAROUSEL:
            return {
                ...state,
                carouselFocus: action.listingId,
            };

        case CLEAR_CAROUSEL_FOCUS:
            return {
                ...state,
                carouselFocus: null,
            };

        case HIDE_GOOGLE_MAP:
            return {
                ...state,
                hideGoogleMap: true,
            };

        default:
            return state;
    }
}
